var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrincess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_83_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 14,
    width: 54,
    height: 52
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6704 14.2036H13.8394V65.6767H66.6704V14.2036Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_83_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.8726 15.022H14.6582V64.8784H65.8726V15.022Z",
    stroke: "#343333",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8244 21.855H21.6853V58.0241H58.8244V21.855Z",
    stroke: "#343333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3924 32.6324L47.4864 26.791L32.9368 26.8341L27.0955 32.7402L27.1386 47.2897L32.9153 53.0664H47.6373L53.4571 47.1819L53.414 32.6324H53.3924Z",
    stroke: "#343333",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9368 26.8341L14.6582 15.022L27.0738 32.7401",
    stroke: "#343333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3924 32.6323L65.8512 15.022L47.4648 26.7909",
    stroke: "#343333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6157 53.0666L65.8512 64.8571L53.4355 47.1821",
    stroke: "#343333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1169 47.2905L14.6582 64.8578L32.8936 53.0672",
    stroke: "#343333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrincess);
export default __webpack_public_path__ + "static/media/Princess.879cd4513295f245daa3613ac7c64edf.svg";
export { ForwardRef as ReactComponent };